import { render, staticRenderFns } from "./OverparkingTable.vue?vue&type=template&id=70284b97&scoped=true"
import script from "./OverparkingTable.vue?vue&type=script&lang=js"
export * from "./OverparkingTable.vue?vue&type=script&lang=js"
import style0 from "./OverparkingTable.vue?vue&type=style&index=0&id=70284b97&prod&lang=scss&scoped=true"
import style1 from "./OverparkingTable.vue?vue&type=style&index=1&id=70284b97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70284b97",
  null
  
)

export default component.exports